const footerLinks = {
  快速导航: [
    { label: '首页', href: '#hero' },
    { label: '热门专题', href: '#index' },
    { label: '焦点速递', href: '#carousel' },
    { label: '吃瓜榜单', href: '#ranking' },
  ],
  内容板块: [
    { label: '精彩爆料', href: '#media' },
    { label: '最新快讯', href: '#updates' },
    { label: '话题广场', href: '#topics' },
    { label: '精选推荐', href: '#cards' },
  ],
  关于平台: [
    { label: '关于我们', href: '#about' },
    { label: '联系投稿', href: '#contact' },
    { label: 'APP下载', href: '#app' },
    { label: '常见问答', href: '#faq' },
  ],
};

const partners = [
  '合作伙伴A', '合作伙伴B', '合作伙伴C',
  '合作伙伴D', '合作伙伴E', '合作伙伴F',
  '合作伙伴G', '合作伙伴H',
];

export default function Footer() {
  const handleNav = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto py-12 md:py-16">
        {/* Top row */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-bold text-sm">
                51
              </span>
              <span className="font-heading text-lg text-background-50">
                51吃瓜视频
              </span>
            </div>
            <p className="text-background-400 text-sm leading-relaxed mb-4">
              51吃瓜视频网是国内领先的吃瓜爆料视频聚合平台，通过51吃瓜官网全网最新入口，提供最新最全的娱乐八卦与热点资讯视频。本站为51吃瓜网站首页官方地址。
            </p>
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:text-background-100 cursor-pointer transition-colors">
                <i className="ri-weibo-line text-sm"></i>
              </div>
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:text-background-100 cursor-pointer transition-colors">
                <i className="ri-wechat-line text-sm"></i>
              </div>
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:text-background-100 cursor-pointer transition-colors">
                <i className="ri-video-line text-sm"></i>
              </div>
            </div>
          </div>

          {/* Link columns */}
          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h3 className="font-heading text-sm text-background-50 mb-4">
                {title}
              </h3>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      onClick={(e) => { e.preventDefault(); handleNav(link.href); }}
                      className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Partners */}
        <div className="border-t border-background-800 pt-8 mb-8">
          <h3 className="font-heading text-sm text-background-300 mb-4 text-center">
            合作伙伴
          </h3>
          <div className="flex flex-wrap justify-center gap-6">
            {partners.map((name, i) => (
              <span
                key={i}
                className="text-sm text-background-500 whitespace-nowrap"
              >
                {name}
              </span>
            ))}
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-background-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; 2020 - 2026 51吃瓜视频网 51chigua.com 版权所有
          </p>
          <p className="text-xs text-background-500">
            本站内容仅供娱乐参考，不构成任何建议
          </p>
        </div>
      </div>
    </footer>
  );
}